<template>

  <v-container fluid class="pa-0" v-if="notificationItems && notificationItems.length > 0">

    <!-------------------->
    <!-- Action List UI -->
    <!-------------------->
    <v-container fluid class="py-4 ma-0 location-shipper-notifications">
      <v-row>
        <v-col cols="12">
          <div class="align-center justify-s">
            <div class="d-flex align-center justify-center">
              <v-icon style="font-size:28px;" class="mr-2" color="#FFD600">mdi-alert-outline</v-icon>
              <span style="color:#FFD600" class="action-title">Licenses Have Changed</span>
            </div>
            <div class="action-info d-flex align-center justify-center mt-4">
              <div align="center">
                <div v-if="notificationItems.length === 1">{{ notificationItems.length }} location has updated their license information.</div>
                <div v-else-if="notificationItems.length > 1">{{ notificationItems.length }} locations have updated their license information.</div>
                <div class="pt-2 action-info-highlight">Please ensure the new information is reflected in your order system.</div>
              </div>
            </div>
            <template v-if="notificationItems.length > 0">
              <div class="d-flex align-center justify-center mt-4">
                <v-btn text icon color="#d9d9d9" @click="showNotifications = !showNotifications">
                  <span class="mr-1">Locations with changes</span>
                  <v-icon v-if="!showNotifications">mdi-chevron-down</v-icon>
                  <v-icon v-else>mdi-chevron-up</v-icon>
                </v-btn>
              </div>
              <transition name="fade" appear>
                <div style="max-width:840px;margin: 0 auto;" class="mb-4 mt-0 pl-4 more-info-text" v-if="showNotifications">
                  <v-row class="mt-2" align="center" justify="center">
                    <v-col cols="4">
                      <div class="notification-header-text">Location</div>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center justify-center">
                      <div class="notification-header-text">Date changed</div>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center justify-center">
                      <div class="notification-header-text">Dismiss</div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                              color="grey lighten-1"
                              style="font-size:22px;cursor:pointer;margin-left:8px"
                              v-bind="attrs"
                              v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div>This will dismiss notifications for your entire Org.</div>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2" v-for="(change, index) in notificationItems" :key="`changed-${index}`">
                    <v-col cols="4">
                      <router-link class="item-link" :to="generateLocationPageLink(change.receiver)">
                        {{ change.receiver.name }}
                      </router-link>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center justify-center">
                      <div v-if="change.approved_licenses_record">
                        {{ formatDate(change.approved_licenses_record.approved_at) }}
                      </div>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center justify-center">
                      <v-btn outlined height="30" color="amber darken-3" @click="dismissNotification(change)">
                        <span style="font-size:0.84rem;">Dismiss</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </transition>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-container>

  </v-container>

</template>

<script>
export default {
  name: 'LocationShipperNotifications',

  props: {
    locationType: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isDataLoading: false,
      dataLoadingError: null,
      dismissError: null,
      notificationData: null,
      showNotifications: false
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    },
    notificationItems () {
      return (this.notificationData) ? this.notificationData.items : []
    }
  },

  async beforeMount () {
    this.loadNotifications()
  },

  methods: {
    formatDate (date) {
      return (date) ? this.$root.utils.dateFormat(date, 'MMMM D, YYYY') : ''
    },

    // Generate link data for location page
    generateLocationPageLink (item) {
      if (item && item.model) {
        const linkData = {
          name: `${this.locationType}-item`,
          params: {}
        }
        linkData.params[`${this.locationType}Id`] = item.id
        return linkData
      } else {
        return ''
      }
    },

    // Dismisses a notification (changed license record)
    async dismissNotification (item) {
      if (!item || !item.id) return false

      try {
        await this.$store.dispatch('sh/dataApi', {
          method: 'post',
          uri: `${this.locationType}-license-change/${item.id}/dismiss`
        })

        // Reload notifications
        this.loadNotifications()
      } catch (err) {
        this.dismissError = err.message || err.text || err
      }
    },

    // Loads un-dismissed receipt records for notifications
    async loadNotifications () {
      try {
        this.isDataLoading = true

        this.notificationData = await this.$store.dispatch('sh/dataApi', {
          method: 'get',
          uri: `${this.locationType}-license-changes`,
          opts: {
            params: {
              is_dismissed: false,
              with: `${this.locationType},approved_licenses_record`
            }
          }
        })
      } catch (err) {
        this.dataLoadingError = err.message || err.text || err
      } finally {
        this.isDataLoading = false
      }
    }
  }
}
</script>

<style scoped>
  a.item-link {
    text-decoration: none;
  }

  a.item-link:hover {
    text-decoration: underline;
  }

  .location-shipper-notifications {
    color: #FF9D29;
    border: 1px solid #FF9D29;
    border-radius: 4px;
  }

  .location-shipper-notifications .action-title {
    font-size: 1.3rem;
    font-weight: 500;
  }

  .location-shipper-notifications .action-info {
    font-size: 1.05rem;
    color: #9c9c9c;
  }

  .location-shipper-notifications .action-info-highlight {
    font-size: 1.1rem;
  }

  .location-shipper-notifications .more-info-text {
    color: #ffffff;
  }

  .location-shipper-notifications .notification-header-text {
    color: #727272;
  }
</style>
